// Delete questionnaire and page modal titles
export const DELETE_QUESTIONNAIRE_TITLE = "Delete questionnaire";
export const DELETE_QUESTION_PAGE_TITLE = "Delete question page";
export const DELETE_INTRODUCTION_PAGE_TITLE = "Delete introduction page";
export const DELETE_SECTION_TITLE = "Delete section";
export const DELETE_FOLDER_TITLE = "Delete folder";
export const DELETE_CONFIRMATION_QUESTION_TITLE =
  "Delete confirmation question";
export const DELETE_CALCULATED_SUMMARY_TITLE = "Delete calculated summary";
export const DELETE_LIST_COLLECTOR_TITLE = "Delete list collector";
export const DELETE_ANSWER_TITLE = (answerTypeText) =>
  `Delete ${answerTypeText} answer`;
export const DELETE_OPTION_TITLE = "Delete option";
export const DELETE_LIST_ITEM_TITLE = "Delete collection list";

// Delete action modal titles
export const DELETE_LOGIC_RULE_TITLE = "Delete logic rule";
export const DELETE_LOGIC_CONDITION_TITLE = "Delete logic condition";
export const DELETE_LOGIC_OR_STATEMENT = "Delete OR statement";
export const DELETE_METADATA_TITLE = "Delete sample file data";
export const DELETE_COMMENT_TITLE = "Delete comment";
export const DELETE_NOTE_TITLE = "Delete note";
export const DELETE_COLLAPSIBLE_TITLE = "Delete collapsible";
export const DELETE_CALC_SUM_ANSWER_TITLE = "Remove answer";
export const DELETE_ALL_CALC_SUM_ANSWERS_TITLE = "Remove all answers";

// Delete warning messages
export const DELETE_PAGE_WARNING =
  "All edits, properties and routing settings will also be removed.";
export const DELETE_QUESTIONNAIRE_WARNING =
  "This questionnaire including all sections and questions will be deleted.";
export const DELETE_FOLDER_WARNING =
  "The folder and all its contents will be removed.";

// Delete button text
export const DELETE_BUTTON_TEXT = "Delete";
